/* global google */

export const createAdvancedMarker = async ({
    latlng,
    map,
    id,
    html,
    title,
    zIndex = 1,
    collisionBehavior = google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY,
    AdvancedMarkerElement = null
}) => {
    const container = document.createElement('div');
    container.style.display = 'block';
    container.style.width = 'max-content';
    container.insertAdjacentHTML('afterbegin', html.trim());
    const content = container.firstElementChild;

    const marker = new AdvancedMarkerElement({
        map,
        position: latlng,
        content: content,
        title: title,
        zIndex: zIndex,
        collisionBehavior: collisionBehavior
    });

    marker.id = id;
    
    marker.getPosition = () => {
        const pos = marker.position;
        if (typeof pos.lat === 'function') return pos;
        return new google.maps.LatLng(pos.lat, pos.lng);
    };
    marker.getVisible = () => true;
    marker.getDraggable = () => false;
    marker.getZIndex = () => marker.zIndex;
    
    marker.update = (newHtml) => {
        if (typeof newHtml !== 'string') return;
        const temp = document.createElement('div');
        temp.innerHTML = newHtml.trim();
        const newElement = temp.firstElementChild;
        marker.content = newElement;
    };

    return marker;
};